module.exports = __webpack_public_path__ + "static/media/17-item-a.063187d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/17-item-a.jpg
// module id = 1200
// module chunks = 33